<template>
  <div class="user-descript">
    <div class="wrapper">
      <div class="info-left">
        <img class="avatar"
             :src="userInfo.user_pfrofile_photo"
             alt />
        <div class="name">{{userInfo.wechat_nick_name}}</div>
      </div>
      <div class="info-center">
        <div class="title-top">
          <div class="item">
            <span>真实姓名：</span>
            <span>{{userInfo.user_nick_name}}</span>
          </div>
          <div class="item">
            <span>单位：</span>
            <span>{{userInfo.company}}</span>
          </div>
          <div class="item">
            <span>职位：</span>
            <span>{{userInfo.career}}</span>
          </div>
        </div>
        <div class="title-bottom">
          <div class="item">
            <span>手机号码：</span>
            <span>{{userInfo.mobile}}</span>
          </div>
          <div class="item">
            <span>邮箱：</span>
            <span>{{userInfo.email}}</span>
          </div>
        </div>
      </div>

      <div class="info-right">
        <el-button type="primary"
                   @click="privateMessage(userInfo,'1')">发消息</el-button>
        <el-button type="primary"
                   @click="editUserInfo()">编辑</el-button>
      </div>
    </div>

    <div class="table-content">
      <el-row class="mt40">
        <el-tabs v-model="activeName"
                 @tab-click="handleClick">
          <el-tab-pane :label="item"
                       :name="String(index)"
                       v-for="(item,index) in tabData"
                       :key="index"></el-tab-pane>
        </el-tabs>
      </el-row>
      <el-row class="mt20">
        <InfoRecord v-if="activeName==0"
                    :user_id="$route.query.user_id"></InfoRecord>
        <BuyRecord v-if="activeName==1"
                   :user_id="$route.query.user_id"></BuyRecord>
        <UserComment v-if="activeName==2"
                     :user_id="$route.query.user_id"></UserComment>
        <HeardCourse v-if="activeName==3"
                     :user_id="$route.query.user_id"></HeardCourse>
        <UserFeedback v-if="activeName==4"
                      :user_id="$route.query.user_id"></UserFeedback>
        <SyInfo v-if="activeName==5"
                :user_id="$route.query.user_id"></SyInfo>
      </el-row>
    </div>

    <!-- 编辑用户信息弹窗 -->
    <el-dialog title="编辑用户信息"
               :visible.sync="editDialogVisible"
               width="30%">
      <el-form ref="form"
               :model="form"
               label-width="100px">
        <el-form-item label="真实姓名：">
          <el-input v-model="form.user_nick_name"
                    placeholder="请输入真实姓名"></el-input>
        </el-form-item>
        <el-form-item label="手机号码：">
          <el-input v-model="form.mobile"
                    placeholder="请输入手机号码"></el-input>
        </el-form-item>
        <el-form-item label="邮箱：">
          <el-input v-model="form.email"
                    placeholder="请输入邮箱"></el-input>
        </el-form-item>
        <el-form-item label="单位：">
          <el-input v-model="form.company"
                    placeholder="请输入单位名称"></el-input>
        </el-form-item>
        <el-form-item label="职位：">
          <el-input v-model="form.career"
                    placeholder="请输入职位"></el-input>
        </el-form-item>
      </el-form>
      <span slot="footer"
            class="dialog-footer">
        <el-button @click="editDialogVisible = false">取 消</el-button>
        <el-button type="primary"
                   @click="userSingleEdit()">确 定</el-button>
      </span>
    </el-dialog>

    <!-- 修饰符传参，可以通过子组件的方法更新值的状态或者值 -->
    <PrivateMessage :privateVisible.sync="privateVisible"
                    :private_info="private_info"
                    :messageType="messageType"></PrivateMessage>
  </div>
</template>


<script>
//发送信息弹框
import PrivateMessage from "../components/private-message";

//引入混合mixins模式
import user_mixins from "../components/user-mixins.js";

//获取单个的用户信息
import { _userSingleInfo, _userSingleEdit } from "@/api/user.js";

import qs from "qs";

//引入用户列表信息表格组件
//信息采集记录
import InfoRecord from "./info-record";
//购买记录
import BuyRecord from "./buy-record";
//用户评论
import UserComment from "./user-comment";
//听过的课程
import HeardCourse from "./heard-course";
//用户反馈
import UserFeedback from "./user-feedback";
//系统消息
import SyInfo from "./sy-info";

export default {
  created () {
    this.userSingleInfo();
  },
  mixins: [user_mixins],
  components: {
    InfoRecord,
    BuyRecord,
    UserComment,
    HeardCourse,
    UserFeedback,
    SyInfo,
    PrivateMessage //发私人消息
  },
  data () {
    return {
      activeName: "0",
      editDialogVisible: false,
      tabData: [
        "信息采集记录",
        "购买记录",
        "用户评论",
        "听过的课程",
        "用户反馈",
        "系统消息"
      ],
      form: {
        user_id: "",
        mobile: "",
        email: "",
        company: "",
        career: "",
        user_nick_name: ""
      },
      //用户信息
      userInfo: {}
    };
  },
  methods: {
    handleClick (tab, event) {
      // console.log(tab);
    },
    //编辑用户信息
    editUserInfo () {
      //遍历原始数据
      for (const key in this.form) {
        this.form[key] = this.userInfo[key];
      }
      // console.log(this.form);
      this.editDialogVisible = true;
    },
    //获取单个信息
    userSingleInfo () {
      _userSingleInfo({
        params: {
          user_id: this.$route.query.user_id
        }
      }).then(res => {
        if (res.resultCode == 1) {
          this.userInfo = res.result;
        } else {
          this.$message.error(res.errorMsg);
        }
      });
    },
    //编辑单个用户信息
    userSingleEdit () {
      let data = { ...this.form }
      _userSingleEdit({
        data: qs.stringify(data)
      }).then(res => {
        if (res.resultCode == 1) {
          this.$message.success(res.errorMsg);
          this.userSingleInfo();
        } else {
          this.$message.error(res.errorMsg);
        }
        this.editDialogVisible = false;
      });
    }
  }
};
</script>


<style lang="less" scoped>
.user-descript {
  .wrapper {
    height: 140px;
    width: 100%;
    padding: 20px;
    background: #fefefe;
    border-radius: 22px;
    padding-left: 20px;
    display: flex;
    align-items: center;
    flex-direction: row;
    .info-left {
      flex: 2;
      display: flex;
      align-items: center;
      .avatar {
        width: 50%;
        max-width: 120px;
        border-radius: 50%;
        margin-right: 20px;
      }
      .name {
        font-size: 22px;
      }
    }
    .info-center {
      flex: 5.5;
      height: 100px;
      // overflow: hidden;
      padding: 20px;
      .title-top {
        width: 100%;
        .item {
          width: 30%;
          margin-right: 20px;
          line-height: 25px;
          display: inline-block;
          overflow: hidden;
          text-overflow: ellipsis;
          white-space: nowrap;
          span:first-child {
            margin-right: 10px;
          }
        }
        .item:last-child {
          margin-right: 0;
        }
      }
      .title-bottom {
        width: 100%;
        .item {
          width: 220px;
          display: inline-block;
          line-height: 40px;
          overflow: hidden;
          text-overflow: ellipsis;
          white-space: nowrap;
          span:first-child {
            margin-right: 10px;
          }
        }
      }
    }
    .info-right {
      flex: 2.5;
      text-align: right;
      padding-right: 20px;
      button:first-child {
        margin-right: 20px;
      }
    }
  }
}
</style>
